import React from 'react'
import styled from '@emotion/styled'

import Stat from '../Stat'

const Root = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
`

const Section = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 14px 17px;
`

const Divider = styled.div`
  border-left: 1px solid rgba(0, 0, 0, 0.3);
  border-right: 1px solid rgba(255, 255, 255, 0.04);
`

const Stub = styled.div``

const SubSections = styled.div`
  display: flex;
`

const SubSection = styled.div`
  flex-shrink: 0;
  padding-right: 20px;  
`

const Status = styled.div`
  color: rgba(255, 255, 255, 0.6);                                                            
  font: 11px/2 Merriweather, serif;
  font-style: italic;
  cursor: help;
`

const LogOutLink = styled.a`
  color: #6db170;
  text-decoration: none;
  border-bottom: 1px solid #447545;
  line-height: 1;
`

const LetterContainer = styled.span`
  position: relative;
  top: 2px;
  margin-right: 5px;
  
  svg {
    fill: ${({active}) => active ? '#6fb971' : '#bdbdbd'};
  }
`

const Letter = () => <svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="0 0 32 30" width="13px">
  <polygon points="29,8.86 21.18,15.76 29,23.58 31,25.58 31,7.1   "/>
  <polygon points="10.82,15.76 3,8.86 1,7.1 1,25.58 3,23.58   "/>
  <path d="M16,17.67L28.09,7l2.21-1.95C30.21,5.02,30.1,5,30,5H2C1.9,5,1.79,5.02,1.7,5.05L3.91,7L16,17.67z"/>
  <path d="M19.67,17.09l-3.01,2.66c-0.11,0.1-0.23,0.17-0.36,0.2c-0.04,0.02-0.08,0.03-0.12,0.03C16.12,20,16.06,20,16,20
   s-0.12-0.01-0.18-0.02c-0.04,0-0.08-0.01-0.12-0.03c-0.13-0.04-0.25-0.1-0.36-0.2l-3.01-2.66L4.42,25l-2,2h27.16l-2-2L19.67,17.09 z"/>
</svg>

const UserStats = ({
  currentUser: {
    login,
    stats: {
      premiumWalletValue,
      frozenWalletValue,
      coinWalletValue,
      coinProgram,
      coinCount,
      mainStatus,
      nextMainStatus,
      nextMainStatusDescription,
      calcCoins,
      mainPeriodSales,
      clientStatus,
      selfClientVolume,
      clientPeriodSales,
      officeDaysLeft,
      messagesCount,
    }
  }
}) => {
  const calcCoinsTitle = nextMainStatus
    ? `Следующая квалификация: ${nextMainStatus}. ${nextMainStatusDescription}`
    : `Поздравляем! Достигнута максимальная квалификация.`

  return <Root>
    <Divider/>
    <Section>
      <Stat value={0} currency="₽" label="на расчётном кошельке" pluralize={false} valueHint hintCurrency="₽"/>
      <Stat value={premiumWalletValue} label="{премиальный балл|премиальных балла|премиальных баллов}" valueHint hintCurrency="Б"/>
      <Stat value={coinWalletValue} label="{жетонный балло|жетонных балла|жетонных баллов}" valueHint hintCurrency="Б"/>
    </Section>
    <Divider/>
    <Section>
      <Status title="Квалификация по основной программе">{mainStatus}</Status>
      <SubSections>
        <SubSection>
          <Stat value={coinCount} label="{личный жетон|личных жетона|личных жетонов}"/>
          <Stat value={coinProgram} label="-программа" pluralize={false} noSpace/>
        </SubSection>
        <SubSection>
          <Stat value={calcCoins} title={calcCoinsTitle} label="{квалиф. жетон|квалиф. жетона|квалиф. жетонов}"/>
          <Stat value={mainPeriodSales} label="{жетон|жетона|жетонов} в периоде"/>
        </SubSection>
      </SubSections>
    </Section>
    <Divider/>
    <Section>
      <Status title="Квалификация по клиентской программе за прошлый период">{clientStatus}</Status>
      <Stat value={selfClientVolume} label="{балл|балла|баллов} личного объема" minWarning={2700} valueHint hintCurrency="Б"/>
      <Stat value={clientPeriodSales} label="{балл|балла|баллов} в периоде" valueHint hintCurrency="Б"/>
    </Section>
    <Divider/>
    <Section>
      <Stat value={login} label={<LogOutLink href='https://mageric.life/main.asp?WW_ID=21863'>выйти</LogOutLink>}/>
      <Stat
        value={messagesCount}
        label={<LetterContainer active={messagesCount > 0}>
          <Letter/>
        </LetterContainer>}
        link="https://mageric.life/main.asp?WW_ID=3375762"
      />
      {officeDaysLeft < 31 && <Stat value={officeDaysLeft} label="{день|дня|дней} обслуживания" minWarning={31}
        title="Оплатите информационное обслуживание для продолжения использования офиса"/>}
    </Section>
    <Stub/>
  </Root>
}

export default UserStats
